import React, { useState, useEffect, useRef } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Button } from "primereact/button";
import { InputText } from "primereact/inputtext";
import Consts from "../../utilities/Consts";
import * as NetworkHelper from "../../utilities/Networkhelper";

import CommonHelper from "../../utilities/CommonHelper";
import { Sidebar } from "primereact/sidebar";
import { BlockUI } from "primereact/blockui";
import { Menu } from "primereact/menu";
import { useStateValue } from "../../utilities/StateProvider";
import DropDownHelper from "../../utilities/DropDownHelper";
import { LkAuthDialog } from "../../components/LkAuthDialog";
import { CustomerBalanceEdit } from "./CustomerBalanceEdit";

const ini_filter = {
  id: { value: undefined, matchMode: Consts.KEYS.FilterMatchMode.EQUALS },
  cus_code: { value: undefined, matchMode: Consts.KEYS.FilterMatchMode.EQUALS },
  unvan: { value: undefined, matchMode: Consts.KEYS.FilterMatchMode.CONTAINS },
  cus_surname: { value: undefined, matchMode: Consts.KEYS.FilterMatchMode.CONTAINS },
  cus_name: { value: undefined, matchMode: Consts.KEYS.FilterMatchMode.CONTAINS },
  cus_firm: { value: undefined, matchMode: Consts.KEYS.FilterMatchMode.CONTAINS },
  country_code: { value: undefined, matchMode: Consts.KEYS.FilterMatchMode.CONTAINS },
  cus_city: { value: undefined, matchMode: Consts.KEYS.FilterMatchMode.CONTAINS },
  name: { value: undefined, matchMode: Consts.KEYS.FilterMatchMode.CONTAINS },
  cus_is_aktive: { value: undefined, matchMode: Consts.KEYS.FilterMatchMode.CONTAINS },
  cus_email: { value: undefined, matchMode: Consts.KEYS.FilterMatchMode.CONTAINS },
  cus_dnd: { value: undefined, matchMode: Consts.KEYS.FilterMatchMode.EQUALS },
  balance: { value: 0, matchMode: Consts.KEYS.FilterMatchMode.NOT_EQUALS },
  adres: { value: undefined, matchMode: Consts.KEYS.FilterMatchMode.CONTAINS },
  pk: { value: undefined, matchMode: Consts.KEYS.FilterMatchMode.CONTAINS },
  bolge: { value: undefined, matchMode: Consts.KEYS.FilterMatchMode.CONTAINS },
  sehir: { value: undefined, matchMode: Consts.KEYS.FilterMatchMode.CONTAINS },
  ulke: { value: undefined, matchMode: Consts.KEYS.FilterMatchMode.CONTAINS },
  cus_tel1: { value: undefined, matchMode: Consts.KEYS.FilterMatchMode.CONTAINS },
  cus_tel2: { value: undefined, matchMode: Consts.KEYS.FilterMatchMode.CONTAINS },
  cus_gsm: { value: undefined, matchMode: Consts.KEYS.FilterMatchMode.CONTAINS },
  cus_fax: { value: undefined, matchMode: Consts.KEYS.FilterMatchMode.CONTAINS },
  cus_private: { value: undefined, matchMode: Consts.KEYS.FilterMatchMode.CONTAINS },
  cus_random: { value: undefined, matchMode: Consts.KEYS.FilterMatchMode.DATE_IS },
  rand_user: { value: undefined, matchMode: Consts.KEYS.FilterMatchMode.EQUALS },
  rand_tar: { value: undefined, matchMode: Consts.KEYS.FilterMatchMode.DATE_IS },
};
export const CustomerListWithBalance = (props) => {
  const { } = props;
  const cLabels = Consts.localizedStrings;
  const baseUrl = Consts.network.customers;
  const [{ user, userLanguage, isAdmin }, dispatch] = useStateValue();
  const defaultSortField = "id";
  const [totalRecords, setTotalRecords] = useState(0);
  const [datalist, setDatalist] = useState([]);
  const [datalistFromDb, setDatalistFromDb] = useState([]); //dbden gelen data
  const [sortField, setSortField] = useState(defaultSortField);
  const [sortOrder, setSortOrder] = useState(-1);
  const [first, setFirst] = useState(0);
  const [selectedDatatableItem, setSelectedDatatableItem] = useState({});
  const [datalistFetchLimit, setDatalistFetchLimit] = useState(100);
  const [offSetStartNum, setOffSetStartNum] = useState(0);
  const [offSetEndNum, setOffSetEndtNum] = useState(100);
  const [totalFetchedCount, setTotalFetchedCount] = useState(100);
  const [dataTableLoading, setDataTableLoading] = useState(false);
  const [globalFilter, setGlobalFilter] = useState(undefined);
  const [filters, setFilters] = useState(ini_filter);
  const [isFragment, setIsFragment] = useState(false);
  const [timerID, setTimerID] = useState(0);
  const [sidebarVisibleCustomerBalance, setSidebarVisibleCustomerBalance] = useState(false);
  const [visibleDeleteItemDialog, setvisibleDeleteItemDialog] = useState(false);
  const [visibleLkAuthDialog, setvisibleLkAuthDialog] = useState(false);
  const [visibleMusteriDosyalari, setvisibleMusteriDosyalari] = useState(false);
  const [visibleCariHareketler, setvisibleCariHareketler] = useState(false);
  const [visibleMusteriGecmisSiparisler, setvisibleMusteriGecmisSiparisler] = useState(false);

  const [blocked, setBlocked] = useState(false);
  const isFirstRender = useRef(true);
  const [ddCusDnd, setDdCusDnd] = useState([]);
  const dt = useRef(undefined);
  const menu = useRef(undefined);

  useEffect(() => {
    dispatch({
      type: "SET_PAGE_HEADER",
      pageHeader: cLabels.customer_list_with_balance,
    });
  }, [userLanguage]);

  useEffect(() => {
    if (isFirstRender.current) {
      if (!isFragment) {
      }
      isFirstRender.current = false;
      init();
    }
  });

  const init = async () => {
    _onList();
  };

  const initFilters = () => {
    setFirst(0);
    setGlobalFilter("");
    setFilters(ini_filter);
    _onFilter(ini_filter, null);
  };
  const onGlobalFilterChange = (e) => {
    setGlobalFilter(e.target.value);
    clearInterval(timerID);
    setTimerID(
      setTimeout(() => {
        const value = e.target.value;
        _onFilter(filters, value);
      }, Consts.filterDelay)
    );
  };
  const _onList = async (_filters = filters, _globalFilter = globalFilter, _sortField = sortField, _sortOrder = sortOrder) => {
    try {
      setDataTableLoading(true);
      setSortField(_sortField);
      setSortOrder(_sortOrder);
      let response = await NetworkHelper.call_web_service(baseUrl.list, {
        ..._filters,
        globalFilter: _globalFilter,
        orderByField: _sortField,
        orderBy: _sortOrder === 1 ? "ASC" : "DESC",
        count: true,
      });
      setDatalist(response.datalist);
      setDatalistFromDb(response.datalist);
      setTotalRecords(response.count);
      setTotalFetchedCount(totalFetchedCount);
    } catch (error) {
      console.log("._onList.catch", error);
      CommonHelper.handleCatch(error);
    } finally {
      setDataTableLoading(false);
    }
  };


  const _onFilter = async (_filters = filters, _globalFilter = globalFilter) => {
    setFilters(_filters);

    await _onList(_filters, _globalFilter, sortField, sortOrder);
  };

  const paginatorRight = () => {
    return (
      <div>
        {user.user_level == 1 && (
          <Button
            type="button"
            icon="pi pi-file-excel"
            className="p-button-success p-button-sm"
            onClick={() => {
              setvisibleLkAuthDialog(true);
            }}
          />
        )}
      </div>
    );
  };

  const header = (
    <div className="table-header">
      <Button type="button" icon="pi pi-filter-slash" label={cLabels.clear} className="p-button-outlined" onClick={initFilters} />
      <span className="p-input-icon-left">
        <i className="pi pi-search" />
        <InputText value={globalFilter} onChange={onGlobalFilterChange} placeholder={cLabels.keyword_search} />
      </span>
    </div>
  );

  const menuModel = [
    {
      label: Consts.localizedStrings.update_balance,
      icon: "pi pi-gift",
      command: () => {
        setSidebarVisibleCustomerBalance(true);
      },
    },

    {
      label: Consts.localizedStrings.musteri_sayfasi,
      icon: "pi pi-desktop",
      command: () => {
        let url = window.location.origin.toString() + "/#/genel-takip?cus_id=" + selectedDatatableItem.id;
        window.open(url, '', `width=${window.screen.width - 200},height=${window.screen.height - 200}, top=100,left=100`)
      },
    },
  ];
  const actionBodyTemplate = (rowData) => {
    return (
      <Button
        icon="pi pi-bars"
        form="xx-form"
        className="p-button-sm p-button-text"
        onClick={(event) => {
          menu.current.toggle(event);
          setSelectedDatatableItem(rowData);
        }}
      />
    );
  };
  return (
    <div className="content-section implementation datatable-filter-demo">
      <BlockUI blocked={blocked} fullScreen />
      <Menu model={menuModel} popup ref={menu} />

      <div className={isFragment ? "" : "card"}>

        <DataTable
          reorderableColumns
          value={datalist}
          dataKey={"id"}
          id="id"
          rowHover
          ref={dt}
          selectionMode="single"
          className="p-datatable-sm"
          currentPageReportTemplate={cLabels.datatable_empty_mesaage}
          sortField={sortField}
          sortOrder={sortOrder}
          selection={selectedDatatableItem}
          onSort={(event) => _onList(filters, globalFilter, event.sortField, event.sortOrder)}
          onFilter={(e) => {
            _onFilter(e.filters);
          }}
          onSelectionChange={(e) => {
            setSelectedDatatableItem(e.value);
            console.log("onSelectionChange:", e.value);
          }}

          filters={filters}
          showGridlines
          resizableColumns
          filterDisplay="row"
          filterDelay={Consts.filterDelay}
          first={first}
          emptyMessage={cLabels.datatable_empty_mesaage}
          loading={dataTableLoading}
          header={header}
          stripedRows
          scrollable

        >
          <Column body={actionBodyTemplate} frozen exportable={false} style={{ maxWidth: "3rem" }} />
          <Column field="id" header={cLabels.id} filter sortable style={{ minWidth: "10rem" }} />
          <Column field="cus_code" header={cLabels.cus_code} filter sortable style={{ minWidth: "10rem" }} />
          <Column field="unvan" header={cLabels.unvan} filter sortable style={{ minWidth: "10rem" }} />
          <Column field="cus_surname" header={cLabels.cus_surname} filter sortable style={{ minWidth: "10rem" }} />
          <Column field="cus_name" header={cLabels.cus_name} filter sortable style={{ minWidth: "10rem" }} />
          <Column field="cus_firm" header={cLabels.firma} filter sortable style={{ minWidth: "10rem" }} />
          <Column field="cus_city" header={cLabels.cus_city} filter sortable style={{ minWidth: "10rem" }} />
          <Column field="balance" header={cLabels.balance} filter sortable style={{ minWidth: "10rem" }} />

        </DataTable>
      </div>
      <Sidebar visible={sidebarVisibleCustomerBalance} position="right" className="p-sidebar-md" closeOnEscape={false} dismissable={false} >
        <CustomerBalanceEdit
          cus_id={selectedDatatableItem.id}
          cus_code={selectedDatatableItem.cus_code}
          cus_firm={selectedDatatableItem.cus_firm}
          balance={selectedDatatableItem.balance}
          onCloseSidebar={(msg, item) => {
            setSidebarVisibleCustomerBalance(false);
            _onList();
          }}
        />
      </Sidebar>
      <LkAuthDialog
        setvisibleDialog={setvisibleLkAuthDialog}
        visibleDialog={visibleLkAuthDialog}
        accept={() => {
          CommonHelper.exportExcel(dispatch, cLabels.cari_cari_liste_header, dt, baseUrl.list, filters, globalFilter, sortField, sortOrder);
        }}
      />
    </div>
  );
};
